import { Component, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AlertController, IonPopover, PopoverController, ViewWillEnter } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { ConstructionSiteWsDao } from "../../core/dao/ws/constructionSite.ws.dao";
import { ReturnSearchResultDto } from "../../core/dto/returnSearchResult.dto";
import { ServersConnectionsProvider } from "../../core/providers/serversConnections.provider";
import { UserService } from "../../core/services/user.service";
import { NavControllerExtended } from "../../gyzmo-commons/helpers/navControllerExtended";
import { DATE_FORMAT } from "../../gyzmo-commons/interfaces/constants";
import { DateProvider } from "../../gyzmo-commons/interfaces/dateProvider";

@Component({
    selector: "app-contract-search",
    templateUrl: "./contract-search.page.html",
    styleUrls: ["./contract-search.page.scss"],
})
export class ContractSearchPage implements ViewWillEnter {
    @ViewChild("popover", { static: false }) popover: IonPopover;

    type: string = "";

    Array = Array;

    returnSearchResults: ReturnSearchResultDto[] = null;
    searchTerm: string = "";
    searching: boolean = false;

    constructor(private navCtrl: NavControllerExtended,
                private serversConnectionsProvider: ServersConnectionsProvider,
                private constructionSiteWsDao: ConstructionSiteWsDao,
                private userService: UserService,
                private popoverController: PopoverController,
                private alertController: AlertController,
                private translateService: TranslateService,
                private dateProvider: DateProvider,
                private route: ActivatedRoute) {
    }

    ionViewWillEnter(): void {
        this.type = this.route.snapshot.paramMap.get("type");
    }

    public setCurrentDate() {
        this.searchTerm = this.dateProvider.now().toFormat(DATE_FORMAT);
    }

    public async search() {
        this.searching = true;
        let user = await this.userService.getCurrentUserWithThirdPartyOnly();
        switch (this.type) {
            case "departure":
                void this.constructionSiteWsDao.searchByDeparture(this.serversConnectionsProvider.getPrimaryServerConnection(), this.searchTerm, user.company.id)
                    .then((returnSearchResults: ReturnSearchResultDto[]) => {
                        this.returnSearchResults = returnSearchResults;
                        this.searching = false;
                    });
                break;
            case "return":
                void this.constructionSiteWsDao.searchByReturn(this.serversConnectionsProvider.getPrimaryServerConnection(), this.searchTerm, user.company.id)
                    .then((returnSearchResults: ReturnSearchResultDto[]) => {
                        this.returnSearchResults = returnSearchResults;
                        this.searching = false;
                    });
                break;
        }
    }

    startWithContract(returnSearchResultDto: ReturnSearchResultDto) {
        if (this.type == "departure") {
            void this.navCtrl.navigateForward("/home/departure/" + returnSearchResultDto.contractId + "/" + returnSearchResultDto.invoiceId + "/" + returnSearchResultDto.groupingCode);
        } else if (this.type == "return") {
            void this.navCtrl.navigateForward("/home/return/" + returnSearchResultDto.contractId + "/" + returnSearchResultDto.invoiceId + "/" + returnSearchResultDto.groupingCode);
        }
    }

    public openPopover($event) {
        void this.popover.present($event);
    }

    public async help() {
        void this.popoverController.getTop().then((element) => {
            void element.dismiss();
        });
        const alert = await this.alertController.create({
            header: this.translateService.instant("IMCP_Help"),
            message: this.type == "departure" ?
                     this.translateService.instant("IMCP_Vous_pouvez_effectuer_une_recherche_sur_le_code_contrat_le_nom_client_le_nom_chantier_le_code_chantier_la_date_de_départ_(format_JJ/MM/AAAA).")
                                              :
                     this.translateService.instant("IMCP_Vous_pouvez_effectuer_une_recherche_sur_le_code_contrat_le_nom_client_le_nom_chantier_le_code_chantier_le_code_chantier_la_date_de_retour_(format_JJ/MM/AAAA)."),
        });

        await alert.present();
    }
}
